"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactQuery = require("react-query");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _request = require("@nicbase/request");

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseDialogs = require("nicbase-dialogs");

var _nicbaseForms = require("nicbase-forms");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var getCompanyProfileValues = function getCompanyProfileValues(pId) {
  return {
    type: 'GET_COMPANY_PROFILE_REQUEST',
    headers: {
      version: 'v1',
      portalId: pId
    },
    body: {}
  };
};

var TourLinkDialog = function TourLinkDialog(_ref) {
  var onCancel = _ref.onCancel,
      tour = _ref.tour;

  var _usePortal = (0, _nicbaseReducers.usePortal)(),
      portalName = _usePortal.name,
      portalId = _usePortal.id;

  var _useRequest = (0, _request.useRequest)(),
      request = _useRequest.request;

  var intl = (0, _nicbaseTranslation.useIntl)();
  var name = tour.name,
      token = tour.token,
      _tour$segments = tour.segments,
      segments = _tour$segments === void 0 ? [] : _tour$segments,
      _tour$wayPoints = tour.wayPoints,
      wayPoints = _tour$wayPoints === void 0 ? [] : _tour$wayPoints;

  var _useState = (0, _react.useState)(token),
      _useState2 = _slicedToArray(_useState, 2),
      selectedToken = _useState2[0],
      setSelectedToken = _useState2[1];

  var tokenSource = (0, _react.useMemo)(function () {
    return [{
      value: token,
      label: intl.formatMessage({
        id: 'widgets.tourBoard.tourLink.entireTour'
      })
    }].concat(_toConsumableArray(segments === null || segments === void 0 ? void 0 : segments.map(function (segment, index) {
      var _wayPoints$segment$va, _wayPoints$segment$va2;

      return {
        value: segment.token,
        label: "".concat(index + 1, ". ").concat((_wayPoints$segment$va = wayPoints[segment.validityWayPointIndexRange[0]]) === null || _wayPoints$segment$va === void 0 ? void 0 : _wayPoints$segment$va.poiName, " - ").concat((_wayPoints$segment$va2 = wayPoints[segment.validityWayPointIndexRange[segment.validityWayPointIndexRange.length - 1]]) === null || _wayPoints$segment$va2 === void 0 ? void 0 : _wayPoints$segment$va2.poiName)
      };
    })));
  }, [intl, segments, token, wayPoints]); // request to load company profile for image

  var _useQuery = (0, _reactQuery.useQuery)(['portal', portalId, 'companyProfile'], /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _yield$request, body;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return request(getCompanyProfileValues(portalId));

          case 2:
            _yield$request = _context.sent;
            body = _yield$request.body;
            return _context.abrupt("return", body.companyProfile || {});

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }))),
      _useQuery$data = _useQuery.data,
      data = _useQuery$data === void 0 ? {} : _useQuery$data; // create link


  var baseLocation = window.location.origin.toString();
  var tourLink = "".concat(baseLocation, "/data-view?tourToken=").concat(selectedToken, "&tourName=").concat(encodeURIComponent(name), "&portalName=").concat(encodeURIComponent(portalName), "&image=").concat(data === null || data === void 0 ? void 0 : data.imagePath); // create mail content

  var mailSubject = "Tour%20".concat(name);
  var mailBody = encodeURIComponent("".concat(intl.formatMessage({
    id: 'widgets.tourBoard.tourLinkMailBody'
  }, {
    portalName: portalName,
    tourName: name,
    tourLink: tourLink,
    linebreak: '\n'
  }))).replace(/%0A/g, '%0D%0A'); // sort token selection list so that the option for the whole tour is on top

  var sortFunction = function sortFunction(prev, next) {
    var _prev$label$localeCom, _prev$label;

    if (next.value === token) {
      return 1;
    }

    return (_prev$label$localeCom = (_prev$label = prev.label) === null || _prev$label === void 0 ? void 0 : _prev$label.localeCompare(next.label)) !== null && _prev$label$localeCom !== void 0 ? _prev$label$localeCom : 1;
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.Dialog.Body, {
    className: "w-128"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-base"
  }, segments.length > 0 && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Dropdown, {
    className: "pb-6",
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.tourLink.selectTourOrSegment"
    }),
    source: tokenSource,
    value: selectedToken,
    onChange: setSelectedToken,
    sortFunction: sortFunction
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('text-center', {
      'flex flex-col items-center justify-center': segments.length === 0
    }),
    style: {
      minHeight: '19.2rem'
    }
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "pb-5"
  }, selectedToken === token ? /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.tourLink.tourIntro",
    values: {
      tourName: name,
      b: function b(chunks) {
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: "font-bold"
        }, chunks);
      }
    }
  }) : /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.tourLink.segmentIntro",
    values: {
      segmentName: tokenSource[selectedToken],
      b: function b(chunks) {
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: "font-bold"
        }, chunks);
      }
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "pb-5"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "text-primary",
    href: tourLink,
    target: "_blank",
    rel: "noreferrer noopener"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.tourLinkOpen"
  }))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("a", {
    className: "text-primary",
    href: "mailto:?subject=".concat(mailSubject, "&body=").concat(mailBody)
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.tourLinkSend"
  }))))))), /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.Dialog.Footer, null, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    key: "1",
    primary: true,
    raised: true,
    className: "action-button cancel-button",
    onClick: onCancel
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "common.close"
  }))));
};

TourLinkDialog.propTypes = {
  onCancel: _propTypes["default"].func,
  tour: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    token: _propTypes["default"].string,
    segments: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
    wayPoints: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
  }).isRequired
};
TourLinkDialog.defaultProps = {
  onCancel: function onCancel() {}
};
var _default = TourLinkDialog;
exports["default"] = _default;